import { UserRole } from '@nebalkon-workspace/auth';

export interface StaffDashboardVisibility {
  showClientsKpi: boolean;
  showEmployeesKpi: boolean;
  showWarehousesKpi: boolean;
  showBoxTypesKpi: boolean;
  showStorageKpi: boolean;
  showWalletKpi: boolean;
  showClientsTimeline: boolean;
  showWarehousesChart: boolean;
  /** Admin snapshot dashboard (Health / Warehouses / Attention). */
  showAdminLayout: boolean;
}

export function staffDashboardVisibility(
  roles: UserRole[],
): StaffDashboardVisibility {
  const isAdmin = roles.includes(UserRole.Admin);
  const isManager = roles.includes(UserRole.Manager);
  const isWarehouseWorker = roles.includes(UserRole.WarehouseWorker);
  const isFullAccess = isAdmin || isManager;
  const hasStorageAccess = isFullAccess || isWarehouseWorker;

  return {
    showClientsKpi: isFullAccess,
    showEmployeesKpi: isAdmin,
    showWarehousesKpi: hasStorageAccess,
    showBoxTypesKpi: isAdmin,
    showStorageKpi: hasStorageAccess,
    showWalletKpi: isFullAccess,
    showClientsTimeline: isFullAccess,
    showWarehousesChart: hasStorageAccess,
    showAdminLayout: isAdmin,
  };
}
